<nav class="navbar navbar-expand-lg navbar-light bg-light">
  <span class="navbar-brand">Asset Vendors</span>
  <button
    class="navbar-toggler"
    type="button"
    data-toggle="collapse"
    data-target="#navbarSupportedContent"
    aria-controls="navbarSupportedContent"
    aria-expanded="false"
    aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>

  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <span class="mr-auto">
      <button
        mat-raised-button
        color="primary"
        (click)="onAdd()"
        id="add"
        class="m-1 mr-2"
        *ngIf="canCreate">
        <mat-icon>add</mat-icon>
        Add Vendor
      </button>

      <button mat-raised-button class="m-1 mr-2" routerLink="/vendors/importer" matTooltip="Click this button to mass import Vendors from a CSV file." *ngIf="canCreate">
        <mat-icon>cloud_upload</mat-icon> Import
      </button>

      <ng-container *ngIf="canView || canDelete">
        <mat-menu #appMenu="matMenu">
          <button mat-menu-item (click)="dataSource.selectAllToggle()">
            <mat-icon *ngIf="dataSource.isAllSelected()"> clear_all</mat-icon><mat-icon *ngIf="!dataSource.isAllSelected()">select_all</mat-icon>
            {{ dataSource.isAllSelected() ? 'Deselect' : 'Select' }} All
          </button>
          <button *ngIf="dataSource.archived == 'false' && canDelete" mat-menu-item (click)="onRemoveSelected()" [disabled]="!dataSource.selection.hasValue()">
            <mat-icon>archive</mat-icon> Archive Selected
          </button>
          <button *ngIf="dataSource.archived == 'false' && canView" mat-menu-item (click)="onExportSelected('csv')">
            <mat-icon>cloud_download</mat-icon> Export {{ dataSource.selection.hasValue() ? '(' + dataSource.selection.selected.length + ') Selected' : 'All' }} to CSV
          </button>
          <button *ngIf="dataSource.archived == 'true' && canDelete" mat-menu-item (click)="onRestoreSelected()" [disabled]="!dataSource.selection.hasValue()">
            <mat-icon>restore</mat-icon> Restore Selected
          </button>
        </mat-menu>

        <button *ngIf="dataSource.archived == 'false'" mat-button class="m-1 mr-2" [matMenuTriggerFor]="appMenu" matTooltip="Use this menu to select/deselect and/or export Vendor." style="min-width: 150px">
          <mat-icon>more_vert</mat-icon>
          List Menu/Export
        </button>
        <button *ngIf="dataSource.archived == 'true'" mat-button class="m-1 mr-2" [matMenuTriggerFor]="appMenu" matTooltip="Use this menu to select/deselect Vendor." style="min-width: 120px">
          <mat-icon>more_vert</mat-icon>
          List Menu
        </button>
      </ng-container>
    </span>

    <button mat-raised-button class="m-1 mr-lg-3" (click)="onFilter()" matTooltip="Click this button to display filter options." *ngIf="canView">
      <mat-icon>filter_list</mat-icon> Filter
    </button>

    <form class="form-inline mx-1 my-0" (ngSubmit)="dataSource.getData(true)" *ngIf="canView">
      <input
        class="form-control ml-0 mr-2 my-1"
        type="search"
        [(ngModel)]="dataSource.search"
        name="search"
        placeholder="Search"
        aria-label="Search"
        matTooltip="Search for Vendors" />

      <button
        mat-raised-button
        color="secondary"
        type="submit"
        class="mx-0 my-1"
        matTooltip="Run the current search">
        <mat-icon>search</mat-icon> Search
      </button>
    </form>
  </div>
</nav>

<div class="alert alert-warning m-2" *ngIf="!canView">
  <mat-icon class="align-middle mr-2">info</mat-icon>
  You do not have permission to view vendors.
  <span *ngIf="canCreate">You can still create new vendors using the button above.</span>
  <span *ngIf="!canCreate">Please contact your administrator to request access.</span>
</div>

<div class="mat-elevation-z8 scroll-box" *ngIf="canView">
  <table mat-table [dataSource]="dataSource" style="width: 100%" matSort matSortActive="id" matSortDirection="asc" matSortDisableClear>
    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef [style.width.px]="65">
        <mat-checkbox
          (change)="$event ? dataSource.selectAllToggle() : null"
          [checked]="dataSource.selection.hasValue() && dataSource.isAllSelected()"
          [indeterminate]="dataSource.selection.hasValue() && !dataSource.isAllSelected()">
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox
          (click)="$event.stopPropagation()"
          (change)="$event ? dataSource.selection.toggle(row.id) : null"
          [checked]="dataSource.selection.isSelected(row.id)">
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="id">
      <th mat-header-cell mat-sort-header *matHeaderCellDef matTooltip="Toggle sorting by the id of the vendor.">
        #
      </th>
      <td mat-cell *matCellDef="let vendor">
        {{ vendor.id }}
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef class="no-padding" mat-sort-header matTooltip="Toggle sorting by the name of the vendor.">
        Name
      </th>
      <td mat-cell *matCellDef="let vendor" class="no-padding text-wrap">
        {{ vendor.name  }}
      </td>
    </ng-container>

    <ng-container matColumnDef="is_prequalified">
      <th mat-header-cell *matHeaderCellDef class="no-padding">
        Prequalified
      </th>
      <td mat-cell *matCellDef="let vendor" class="no-padding text-wrap">
        {{ vendor.is_prequalified ? 'Yes' : 'No'  }}
      </td>
    </ng-container>

    <ng-container matColumnDef="insurance_last_verified">
      <th mat-header-cell *matHeaderCellDef class="no-padding">
        Insurance Verified Date
      </th>
      <td mat-cell *matCellDef="let vendor" class="no-padding text-wrap">
        {{ vendor.insurance_last_verified_date ? ((vendor.insurance_last_verified_date * 1000) | timezoneConvertMedium) : '' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="insurance_valid_till">
      <th mat-header-cell *matHeaderCellDef class="no-padding" mat-sort-header matTooltip="Toggle sorting by the insurance expiry date of the vendor.">
        Insurance Expiry Date
      </th>
      <td mat-cell *matCellDef="let vendor" class="no-padding text-wrap">
        <span [style.color]="assetsService.getDueDateColor(vendor.insurance_valid_till, app.account.timezone) || null">
            {{ vendor.insurance_valid_till ? (vendor.insurance_valid_till | timezoneConvertMedium) : '' }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="contact_details">
      <th mat-header-cell *matHeaderCellDef class="no-padding">
        Contact
      </th>
      <td mat-cell *matCellDef="let vendor" class="no-padding">
        <div *ngIf="vendor?.email">
          <a [href]="'mailto:' + vendor.email" target="_blank">{{ vendor.email }}</a>
        </div>

        <div *ngIf="vendor?.phone">
          <a [href]="'tel:' + vendor.phone_e164" target="_blank">{{ vendor.phone }}</a>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="linked_assets_count">
      <th mat-header-cell *matHeaderCellDef class="no-padding">
        Linked Assets Count
      </th>
      <td mat-cell *matCellDef="let vendor" class="no-padding text-wrap">
        {{ vendor?.linked_assets_count ?? 0 }}
      </td>
    </ng-container>

    <ng-container matColumnDef="created_by_user">
      <th mat-header-cell *matHeaderCellDef class="no-padding" mat-sort-header matTooltip="Toggle sorting by the user that created the vendor.">
        Created By
      </th>
      <td mat-cell *matCellDef="let vendor" class="no-padding">
        <span *ngIf="vendor?.created_by_user else showSystemCreator">
          <a (click)="onUserPublicView(vendor.created_by_user.hash)" matTooltip="View User Public Profile">
            {{ vendor.created_by_user.contact_person }}
          </a>
        </span>
        <ng-template #showSystemCreator>System</ng-template>
      </td>
    </ng-container>

    <ng-container matColumnDef="date_created">
      <th mat-header-cell *matHeaderCellDef class="no-padding" mat-sort-header matTooltip="Toggle sorting by the created at date of the vendor.">
        Created At
      </th>
      <td mat-cell *matCellDef="let vendor" class="no-padding">
        {{ (vendor.date_created * 1000) | timezoneConvertMedium }}
      </td>
    </ng-container>

    <ng-container matColumnDef="date_created_UTC">
      <th mat-header-cell *matHeaderCellDef class="no-padding" mat-sort-header>
        Created At (UTC)
      </th>
      <td mat-cell *matCellDef="let vendor" class="no-padding">
        {{ (vendor.date_created * 1000) | timezoneConvertUTCMedium }}
      </td>
    </ng-container>

    <ng-container matColumnDef="buttons">
      <th mat-header-cell *matHeaderCellDef [style.width.px]="240"></th>
      <td mat-cell *matCellDef="let vendor">
        <button *ngIf="dataSource.archived == 'false' && canView" type="button" mat-button (click)="onView(vendor.id)">
          View
        </button>

        <button *ngIf="dataSource.archived == 'false' && canEdit" type="button" mat-button (click)="onEdit(vendor)">
          Edit
        </button>

        <button *ngIf="dataSource.archived == 'false' && canDelete" type="button" mat-button (click)="onRemove(vendor)">
          Archive
        </button>

        <button *ngIf="dataSource.archived == 'true' && canDelete" type="button" mat-button (click)="onRestore(vendor.id)">
          Restore
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

  <mat-paginator
    [length]="dataSource?.total | async"
    [pageSize]="dataSource.limit"
    [pageSizeOptions]="dataSource.pageSizeOptions"
    showFirstLastButtons>
  </mat-paginator>
</div>
